export enum CurrencyType {
    SEK = 1,
    DKK = 2,
    EUR = 3,
    NOK = 4,
    GBP = 5,
    USD = 6,
}

export const CurrencyTypes: ICurrencyType[] = [
    { Id: CurrencyType.SEK, TextId: 'billing.sek' },
    { Id: CurrencyType.DKK, TextId: 'billing.dkk' },
    { Id: CurrencyType.EUR, TextId: 'billing.eur' },
    { Id: CurrencyType.NOK, TextId: 'billing.nok' },
    { Id: CurrencyType.GBP, TextId: 'billing.gbp' },
    { Id: CurrencyType.USD, TextId: 'billing.usd' },
];

export interface ICurrencyType {
    Id: CurrencyType;
    TextId: string;
}
